import { t } from '@unistocks/shared/localization/index.ts';
import { Stack } from 'expo-router';

export const unstable_settings = {
  anchor: 'menu'
};

export default function MenuLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: 'transparent' }
      }}
    >
      <Stack.Screen name={'menu'} options={{ title: t('::Menu:More') }} />
      <Stack.Screen name={'savings-goals'} options={{ title: t('::Menu:SavingsGoals') }} />
      <Stack.Screen name={'external-accounts'} options={{ title: t('::ExternalAccounts') }} />
      <Stack.Screen name={'shared-portfolios'} options={{ title: t('::Menu:SharedPortfolios') }} />
      <Stack.Screen name={'settings'} options={{ title: t('::Menu:Settings') }} />
    </Stack>
  );
}
